// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
// need type declaration
import VueSignaturePad from 'vue-signature-pad';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueSignaturePad);
});
